
<mat-dialog-content>
    <mat-form-field class="example-full-width">
        <mat-label>Nota al sector</mat-label>
        <textarea matInput rows="5" [(ngModel)]="note"></textarea>
      </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close color="warn">Cancelar</button>
    <button mat-raised-button [mat-dialog-close]="note" color="primary">Grabar</button>
</mat-dialog-actions>